import { Button } from "@/components/ui/button";

export const EmptyState = ({ icon: Icon, title, description, actionLabel, onAction, testId = "empty-state" }) => (
  <div data-testid={testId} className="flex flex-col items-center justify-center text-center py-16 px-6">
    {Icon && (
      <span className="h-14 w-14 rounded-2xl bg-muted flex items-center justify-center mb-4">
        <Icon className="h-7 w-7 text-muted-foreground" />
      </span>
    )}
    <h3 className="font-heading font-semibold text-lg">{title}</h3>
    {description && <p className="text-sm text-muted-foreground mt-1 max-w-sm">{description}</p>}
    {actionLabel && (
      <Button onClick={onAction} className="mt-5 rounded-lg" data-testid={`${testId}-action`}>
        {actionLabel}
      </Button>
    )}
  </div>
);
